<template lang="html">
  <v-layout row wrap justify-left>
    <v-flex xs12>
      <span class="title">
        Use this Rate Recipe when:
      </span>
    </v-flex>
    <v-flex xs12>
      <v-layout
        row
        wrap
        class="content"
        v-if="!!edit">
        <v-flex xs4 class="selector-container">
          <v-select
            label="Select a Rule"
            :items="availableRules"
            v-model="payload.type"/>
        </v-flex>
        <v-flex xs5 class="input-container">
          <date-picker
            :minDate="new Date().toISOString()"
            :range="true"
            v-if="payload.type === 'date'"
            v-model="payload.value"/>
          <v-text-field
            label="Value"
            type="number"
            v-model="payload.value"
            v-else/>
        </v-flex>
        <v-flex xs3 class="action-container">
          <save-btn class="save-btn" :disabled="disableSave" @click="saveEdit"/>
          <cancel-btn class="cancel-btn" @click="cancelEdit"/>
        </v-flex>
      </v-layout>
      <v-layout
        row
        wrap
        class="content"
        v-else>
        <v-flex xs6 class="type-container">
          <span id="rule-type">
            {{ typeDisplay }}
          </span>
        </v-flex>
        <v-flex xs5 class="value-container">
          <span id="rule-value">
            {{ valueDisplay }}
          </span>
        </v-flex>
        <v-flex xs1 class="action-container">
          <edit-btn class="edit-btn" v-if="payload.type !== 'standard'" @click="initEdit"/>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import EditButton from './EditButton'
import SaveButton from './SaveButton'
import CancelButton from './CancelButton'
import DatePicker from './DatePicker'

export default {
  components: {
    'edit-btn': EditButton,
    'cancel-btn': CancelButton,
    'save-btn': SaveButton,
    'date-picker': DatePicker
  },
  props: {
    rule: { type: Object, required: false, default: () => ({ }) },
  },
  data () {
    return {
      edit: false,
      availableRules: [
        { text: 'Date is', value: 'date' },
        { text: 'Month is', value: 'month' },
        { text: 'Day of week is', value: 'dayofweek' },
        { text: 'Leg miles greater than', value: 'legmileage' },
        { text: 'Trip miles greater than', value: 'totalmileage' },
        { text: 'Daily miles greater than', value: 'dailymileage' },
        { text: 'Trip travel time greater than', value: 'totaltime'},
        { text: 'Daily travel time greater than', value: 'dailytime'},
        { text: 'Leg travel time greater than', value: 'legtime'},
        //{ text: 'Standard', value: 'standard' }
      ],
      payload: {}
    }
  },
  mounted () {
    this.createFreshPayload()
  },
  computed: {
    typeDisplay () {
      if (this.payload.type === 'standard') {
        return 'Standard rate'
      }
      const  r = this.availableRules.find(r => r.value === this.payload.type);
      return !!r ? r.text : ''
    },
    valueDisplay () {
      if (this.payload.type === 'date') {
        return new Date(this.payload.value).toDateString()
      }
      if (this.payload.type === 'standard') {
        return 'Always applies'
      }
      return this.payload.value
    },
    disableSave () {
      return !this.payload.value || !this.payload.type
    }
  },
  watch: {
    rule (val) {
      this.edit = false
      this.createFreshPayload()
    }
  },
  methods: {
    createFreshPayload () {
      this.payload = {
        type: this.rule.type,
        value: this.rule.value
      }
      if (!this.payload.type) { this.edit = true }
    },
    initEdit () {
      this.edit = true
    },
    saveEdit () {
      const payload = this.cleanPayload(this.payload)
      this.edit = false
      this.$emit('save', payload)
    },
    cancelEdit () {
      this.edit = false
      this.payload = this.rule
    },
    cleanPayload (p) {
      const temp = { type: p.type, value: p.value }
      switch (temp.type) {
        case 'date':
          break;
        case 'standard':
          break;
        default:
          temp.value = parseInt(temp.value)
      }
      return temp
    }
  }
}
</script>

<style lang="css" scoped>
.value-container {
  padding-top: 6px;
  padding-bottom: 6px;
}
.type-container {
  padding-top: 6px;
  padding-bottom: 6px;
}
.edit-btn {
  margin: 0px;
}
.delete-btn {
  margin: 0px
}
</style>
